/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../../request';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (requestData: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_0 = 'http://10.50.16.213:40001/mock/283' as any;
const devUrl_0_0_0_0 = '' as any;
const prodUrl_0_0_0_0 = 'http://127.0.0.1' as any;
const dataKey_0_0_0_0 = 'retdata' as any;

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `PUT /api/rulesSet/{id}/status`
 */
export interface IdStatusPutRequest {
  /**
   * 规则集状态
   */
  status?: 1 | 2 | 3;
  /**
   * 规则集id
   */
  id: string;
}

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `PUT /api/rulesSet/{id}/status`
 */
export interface IdStatusPutResponse {}

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `PUT /api/rulesSet/{id}/status`
 */
type ApiRulesSetIdStatusPutRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/283',
    '',
    'http://127.0.0.1',
    '/api/rulesSet/{id}/status',
    'retdata',
    'id',
    string,
    false
  >
>;

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `PUT /api/rulesSet/{id}/status`
 */
const apiRulesSetIdStatusPutRequestConfig: ApiRulesSetIdStatusPutRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/api/rulesSet/{id}/status',
  method: Method.PUT,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: ['id'],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiRulesSetIdStatusPut',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `PUT /api/rulesSet/{id}/status`
 */
export const apiRulesSetIdStatusPut = /*#__PURE__*/ (requestData: IdStatusPutRequest, ...args: UserRequestRestArgs) => {
  return request<IdStatusPutResponse>(prepare(apiRulesSetIdStatusPutRequestConfig, requestData), ...args);
};

apiRulesSetIdStatusPut.requestConfig = apiRulesSetIdStatusPutRequestConfig;

/* prettier-ignore-end */
